import { inject, Injectable } from '@angular/core';

import { EnvironmentEnum } from './enums';
import { WsMidbackPortalThread } from './resources/midback/thread-hub';
import { API_BACKENDS } from './tokens';

@Injectable({
  providedIn: 'root',
})
export class WsService {
  private backends = inject(API_BACKENDS);

  getWsMidbackPortalThread(env: EnvironmentEnum, accessToken: string) {
    return new WsMidbackPortalThread(this.backends[env], accessToken);
  }
}
